// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 592 ? "c15bf2b0" : chunkId) + "." + {"415":"84a555e72e1e9c14","478":"aeabe4e8fa15168f","592":"62038c1325655471"}[chunkId] + ".js";
};